<div class="container mt-5 ps-5 min-vh-79 mb-5">
  <div class="card-header py-3">
    <h1 class="mb-0">Subscriptions / {{ getNameByPageMode }}</h1>
  </div>

  <div class="card h-100 min-vh-79">
    <div class="card-body flex-none row">

      <div class="row">
        <div class="col-12 d-flex justify-content-end pb-5">
          <button class="btn btn-outline-primary rounded-5 d-flex align-items-center justify-content-center gap-2"
                  [routerLink]="'/subscriptions'"
          >
            <mat-icon class="d-flex align-items-center justify-content-center">arrow_back</mat-icon>
            Return to Subscriptions
          </button>
        </div>
      </div>

      <div class="row" *ngIf="loading">
        <div class="col-12 d-flex justify-content-center">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      </div>

      <div class="row" *ngIf="!loading">
        <div class="col-12 d-flex flex-wrap">
          <form [formGroup]="manageForm" class="w-100">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Subscription Name</mat-label>
              <input formControlName="subscriptionName" matInput>
              <mat-error
                *ngIf="manageForm.get('subscriptionName')?.invalid && manageForm.get('subscriptionName')?.touched">
                {{ getFormControlError('subscriptionName') }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Description</mat-label>
              <textarea formControlName="description" matInput rows="3"></textarea>
              <mat-hint align="end">{{ manageForm.get('description')?.value?.length || 0 }}/100</mat-hint>
              <mat-error *ngIf="manageForm.get('description')?.invalid && manageForm.get('description')?.touched">
                {{ getFormControlError('description') }}
              </mat-error>
            </mat-form-field>

            <hr class="w-100 pt-3 pb-3">

            <!-- Features Section -->
            <div class="row" formGroupName="features">
              <div class="col-12">
                <h3 class="mb-4">Features</h3>

                <!-- Basic Features -->
                <div class="card p-4 mb-4">
                  <h4 class="mb-3">Basic Features</h4>

                  <!-- AI Integration -->
                  <div class="mb-4">
                    <mat-slide-toggle formControlName="aiIntegration" color="primary">
                      AI Integration (Optional)
                    </mat-slide-toggle>
                    <div class="text-muted mt-1">Enable AI-based features for this subscription</div>
                  </div>

                  <!-- Max Quiz Respondents -->
                  <div class="mb-4">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Maximum Quiz Respondents per Month</mat-label>
                      <input matInput type="number" formControlName="maxQuizRespondents" min="1">
                      <mat-error *ngIf="getNestedFormControlError('features', 'maxQuizRespondents')">
                        {{ getNestedFormControlError('features', 'maxQuizRespondents') }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- Max Questions Per Quiz -->
                  <div class="mb-4">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Maximum Questions per Quiz</mat-label>
                      <input matInput type="number" formControlName="maxQuestionsPerQuiz" min="1">
                      <mat-error *ngIf="getNestedFormControlError('features', 'maxQuestionsPerQuiz')">
                        {{ getNestedFormControlError('features', 'maxQuestionsPerQuiz') }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <!-- Advanced Settings -->
                <div class="card p-4">
                  <h4 class="mb-3">Advanced Settings</h4>

                  <!-- Questions Order -->
                  <div class="mb-4">
                    <h5 class="mb-2">Questions Order</h5>
                    <div formGroupName="questionsOrder">
                      <mat-slide-toggle formControlName="randomOrder" color="primary" class="mb-2">
                        Random Questions and Answers Order
                      </mat-slide-toggle>
                      <div class="text-muted mb-3">By default, questions and answers are shown in fixed order</div>

                      <mat-slide-toggle formControlName="allowSkipping" color="primary">
                        Allow Answering Questions in Any Order or Skipping
                      </mat-slide-toggle>
                      <div class="text-muted mt-1">By default, questions must be answered in sequence</div>
                    </div>
                  </div>

                  <!-- Test Duration -->
                  <div class="mb-4">
                    <h5 class="mb-2">Test Duration</h5>
                    <div formGroupName="testDuration">
                      <mat-slide-toggle formControlName="enabled" color="primary" class="mb-2">
                        Enable Time Limit
                      </mat-slide-toggle>
                      <div class="text-muted mb-3">By default, no time limit is set</div>

                      <mat-form-field appearance="outline" class="w-100" *ngIf="isTestDurationRequired()">
                        <mat-label>Duration (minutes)</mat-label>
                        <input matInput type="number" formControlName="durationInMinutes" min="1">
                        <mat-error *ngIf="getNestedFormControlError('features.testDuration', 'durationInMinutes')">
                          {{ getNestedFormControlError('features.testDuration', 'durationInMinutes') }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- Honest Respondent Technology -->
                  <div class="mb-4">
                    <h5 class="mb-2">Honest Respondent Technology</h5>
                    <div formGroupName="honestRespondentTech">
                      <mat-slide-toggle formControlName="enabled" color="primary" class="mb-2">
                        Enable Honest Respondent Technology
                      </mat-slide-toggle>
                      <div class="text-muted mb-3">By default, no monitoring is enabled</div>

                      <mat-slide-toggle formControlName="blockOnDetection" color="primary" *ngIf="isHonestRespondentTechEnabled()">
                        Enable Warnings and Test Block
                      </mat-slide-toggle>
                      <div class="text-muted mt-1" *ngIf="isHonestRespondentTechEnabled()">
                        When enabled, suspicious behavior will trigger warnings and may block the test
                      </div>
                    </div>
                  </div>

                  <!-- AI Answer Review -->
                  <div class="mb-4">
                    <mat-slide-toggle formControlName="aiAnswerReview" color="primary">
                      Enable AI Answer Review
                    </mat-slide-toggle>
                    <div class="text-muted mt-1">Enable AI review for descriptive questions</div>
                  </div>
                </div>
              </div>
            </div>

            <hr class="w-100 pt-3 pb-3">

            <div class="row">
              <div class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Monthly Price</mat-label>
                  <input formControlName="monthlyPrice" matInput type="number" step="0.01" min="0.01">
                  <span matPrefix class="ml-2">$&nbsp;</span>
                  <mat-icon matSuffix matTooltip="Enter the monthly subscription price">info</mat-icon>
                  <mat-error *ngIf="manageForm.get('monthlyPrice')?.invalid && manageForm.get('monthlyPrice')?.touched">
                    {{ getFormControlError('monthlyPrice') }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Discounted Monthly Rate for Annual Prepayment</mat-label>
                  <input formControlName="discountedAnnualRate" matInput type="number" step="0.01" min="0">
                  <span matPrefix class="ml-2">$&nbsp;</span>
                  <mat-icon matSuffix matTooltip="Enter a discounted monthly rate for annual prepayment (optional)">
                    info
                  </mat-icon>
                  <mat-hint>Optional - must be ≤ Monthly Price</mat-hint>
                  <mat-error
                    *ngIf="manageForm.get('discountedAnnualRate')?.invalid && manageForm.get('discountedAnnualRate')?.touched">
                    {{ getFormControlError('discountedAnnualRate') }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row mt-3 mb-5" *ngIf="manageForm.get('monthlyPrice')?.value > 0">
              <div class="col-12">
                <div class="card p-3 bg-light">
                  <h4>Annual Pricing Preview</h4>
                  <div class="d-flex justify-content-between">
                    <span>Monthly Price:</span>
                    <span>${{ manageForm.get('monthlyPrice')?.value | number:'1.2-2' }}</span>
                  </div>
                  <div class="d-flex justify-content-between" *ngIf="manageForm.get('discountedAnnualRate')?.value">
                    <span>Discounted Monthly Rate:</span>
                    <span>${{ manageForm.get('discountedAnnualRate')?.value | number:'1.2-2' }}</span>
                  </div>
                  <div class="d-flex justify-content-between fw-bold">
                    <span>Total Annual Price:</span>
                    <span>${{ calculatedAnnualPrice | number:'1.2-2' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-3 mt-4">
              <button type="button"
                      *ngIf="!isEditMode"
                      class="btn btn-secondary rounded-5 d-flex align-items-center justify-content-center gap-2"
                      (click)="saveAsDraft()"
                      [disabled]="submitting">
                <mat-icon class="d-flex align-items-center justify-content-center">save</mat-icon>
                Save as Draft
              </button>
              <button type="button"
                      class="btn btn-primary rounded-5 d-flex align-items-center justify-content-center gap-2"
                      (click)="saveAndPublish()"
                      [disabled]="submitting">
                <mat-icon class="d-flex align-items-center justify-content-center">publish</mat-icon>
                Save and Publish
              </button>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</div>
